import React, { Fragment, useEffect, useState } from "react";
import InfoEditCard from "../../components/Cards/InfoEditCard";
import InfoAddCard from "../../components/Cards/InfoAddCard";
import { FaGraduationCap, FaShare, FaUserTie } from "react-icons/fa";
import { PiBagFill } from "react-icons/pi";
import { HiLightBulb } from "react-icons/hi";
import axiosInstance from "../../services/api/axiosInstance";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import CandidateProfile from "./CandidateProfile";
import Joyride, { STATUS } from "react-joyride";

import images from "../../utils/images";
import Cookie from "js-cookie";
import { MdClear } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import toast from "react-hot-toast";
import InputGroup from "components/Input/InputGroup";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import { formatNumber } from "ReusableFunctions/convertShowingResults";
import { decryptData, encryptData } from "Security/Crypto/Crypto";
import { Card } from "react-bootstrap";
import { IoChevronBackCircle } from "react-icons/io5";

const EmployerPool = () => {
  const [pageContentLoaded, setPageContentLoaded] = useState(false);
  const [allArrayData, setAllArrayData] = useState([]);
  const [shareProfessional, setShareProfessional] = useState(null);
  const [allArrayDataCopy, setAllArrayDataCopy] = useState([]);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState(null);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [professionalId, setProfessionalId] = useState(null);
  const [poolSearch, setPoolSearch] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [isSearchedOnce, setIsSearchedOnce] = useState(false);
  const [empJobGlow, gettingEmpJobGlow] = useState(false)
  const [empJobsData, setEmpJobsData] = useState([]);
  const [sendInviteData, setSendInviteData] = useState({
    professional_id: '',
    job_id: '',
    employer_feedback: '',
    employer_feedback: ''
  })

  const [isShared, setIsShared] = useState(null)

  const [mobileScreen, setMobileScreen] = useState(window.innerWidth);

  //modal handling
  const [show, setShow] = useState(false);
  const [inviteInterviewBtn, setInviteInterviewBtn] = useState(false);
  const handleInterviewModal = () => setShow(!show);

  // JOYRIDE
  const stepsForNoData = [
    {
      target: "body",
      content: (
        <div className="text-center">
          <h4 className="fw-bold mb-4">Welcome to the Talent Pool!</h4>
          <p>
            Explore profiles of top talents, view their skills, experience, and
            education. If there is any profile that matches your requirements,
            please contact 2nd Careers. We will be happy to connect you. Let's
            get started!
          </p>
        </div>
      ),
      placement: "center",
    },
    {
      target: "#searchInputField",
      content:
        "Search Bar Use the search bar to quickly find candidates based on specific skills, experience, education, or organization names. Start typing to see suggestions and filter results efficiently.",
      placement: "bottom",
    },
  ];

  const steps = [
    {
      target: "body",
      content: (
        <div className="text-center">
          <h4 className="fw-bold mb-4">Welcome to the Talent Pool!</h4>
          <p>
            Explore profiles of top talents, view their skills, experience, and
            education. If there is any profile that matches your requirements,
            please contact 2nd Careers. We will be happy to connect you. Let's
            get started!
          </p>
        </div>
      ),
      placement: "center",
    },
    {
      target: "#firstCard",
      content:
        "Each profile card provides a snapshot of the candidate's key information.",
      placement: "top",
    },
    {
      target: "#clickToSeeProfile2",
      content:
        "Click here to access detailed information about the candidate, including their complete work history, skills, education, and more.",
      placement: "top",
    },
    {
      target: "#searchInputField",
      content:
        "Search Bar Use the search bar to quickly find candidates based on specific skills, experience, education, or organization names. Start typing to see suggestions and filter results efficiently.",
      placement: "bottom",
    },
  ];
  const [runForNoData, setRunForNoData] = useState(false);
  const [run, setRun] = useState(false);

  useEffect(() => {
    setRunForNoData(true);
  }, []);

  useEffect(() => {
    setRun(true);
    if (Cookie.get("Prof_id") && ["/employer_dashboard/pool", "/employer_dashboard/pool/"].includes(window.location.pathname)) {
      setIsShared(Cookie.get("Prof_id") ? decryptData(Cookie.get("Prof_id")) : null)
    }

    if (Cookie.get("prof_id_partner") && ["/partner_dashboard/pool", "/partner_dashboard/pool/"].includes(window.location.pathname)) {
      setIsShared(Cookie.get("prof_id_partner") ? decryptData(Cookie.get("prof_id_partner")) : null)
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/employer_dashboard/pool") {
      setInviteInterviewBtn(true);
    }
  }, []);

  useEffect(() => {
    if (
      isShared ||
      (Cookie.get("Prof_id") && ["/employer_dashboard/pool", "/employer_dashboard/pool/"].includes(window.location.pathname)) ||
      (Cookie.get("prof_id_partner") && ["/partner_dashboard/pool", "/partner_dashboard/pool/"].includes(window.location.pathname))
    ) {
      handleViewFullProfile(isShared)
    } else {
      getPoolPageResponse()
    }
  }, [isShared, Cookie.get("Prof_id"), Cookie.get("prof_id_partner")]);

  const handleJoyrideCallbackForNoData = (data) => {
    const { status } = data;
    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
      // Remove a specific cookie
      Cookie.remove("isEmployerPoolFirstVisit");
      Cookie.remove("isPartnerPoolFirstVisit");
    }
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
      // Remove a specific cookie
      Cookie.remove("isEmployerPoolFirstVisit");
      Cookie.remove("isPartnerPoolFirstVisit");
    }
  };

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 588) {
      setMobileScreen(screenWidth);
    } else {
      setMobileScreen(null);
    }
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // scroll to top

  const [isVisible, setIsVisible] = useState(false);

  // Function to handle scroll event
  const handleScroll = () => {
    if (window.pageYOffset > 200) {
      // Adjust this value according to your needs
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: smooth scrolling animation
    });
  };

  // Add scroll event listener
  window.addEventListener("scroll", handleScroll);

  const handlePoolSearch = (e) => {
    if (!isSearched) {
      setIsSearched(true);
    }
    setPoolSearch(e.target.value);
  };

  //search endpoint
  const handleSearchData = async (pagination_num, from_mail) => {
    setPageContentLoaded(false);
    if (!isSearchedOnce || pagination_num === 1) {
      setAllArrayDataCopy([]);
      setIsSearchedOnce(true);
    }

    try {
      let obj;
      if (from_mail) {
        obj = {
          id: 0,
          search_text: from_mail,
        }
      } else {
        obj = {
          page_number: pagination_num,
          search_text: poolSearch.trim(),
        };
      }

      const { data } = await axiosInstance.post(from_mail ? "/pool_dashboard_search" : "/pool_dashboard_meilisearch", obj);
      if (data.error_code === 200) {
        if (isSearchedOnce && pagination_num !== 1) {
          if (!from_mail) {
            setAllArrayDataCopy((allArrayData) => [
              ...allArrayData,
              ...data?.data?.final_result,
            ]);
          } else {
            setAllArrayDataCopy(data?.data?.final_result);
          }
        } else {
          setAllArrayData(data?.data?.final_result);
          setAllArrayDataCopy(data?.data?.final_result);
          setTotalNoOfRecords(data?.data?.total_professionals);
        }
        setTotalNoOfRecords(data?.data?.total_professionals);
        setPageContentLoaded(true);
      }
      else {
        setPageContentLoaded(false);
        setAllArrayDataCopy([]);
        setTotalNoOfRecords(0);
      }
    } catch (Err) {
      console.log(Err);
    }
  };

  //search input enter key down
  const handlekeydown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (poolSearch) {
        setIsSearched(true);
        handleSearchData(1);
      } else {
        toast.error("search field is empty");
      }
    }
  };

  //clear search
  const handleClearSearch = () => {
    setPoolSearch("");
    setIsSearchedOnce(false);

    if (isSearched) {
      setPageContentLoaded(false);
      setIsSearched(false);
      getPoolPageResponse();
    }
  };

  const getPoolPageResponse = async () => {
    const requiredParams = {
      id: 0,
    }

    try {
      const response = await axiosInstance.post("/pool_dashboard_view", requiredParams);
      if (response.data.error_code === 0) {
        setPageContentLoaded(true);
        setAllArrayData(response.data.data.final_result);
        setAllArrayDataCopy(response.data.data.final_result);
        setTotalNoOfRecords(response.data.data.total_professionals);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleLoadMore = async (nextArrayFromId) => {
    if (isSearched) {
      handleSearchData(Math.ceil(allArrayDataCopy?.length / 5) + 1);
    } else {
      setPoolSearch("");
      const requiredParams = {
        id: nextArrayFromId,
      };
      try {
        setLoadMoreLoading(true);
        const response = await axiosInstance.post("/pool_dashboard_view", requiredParams);

        if (response.data.error_code === 0) {
          setPageContentLoaded(true);
          setAllArrayDataCopy((allArrayData) => [
            ...allArrayData,
            ...response.data.data.final_result,
          ]);
        }
        setLoadMoreLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleViewFullProfile = async (professionalId) => {
    setProfessionalId(professionalId);
  };

  const handleInviteTonterview = async (prof_id) => {
    gettingEmpJobGlow(true);
    try {
      setShow(true)
      const { data } = await axiosInstance.post("fetch_employer_jobs", {
        professional_id: prof_id
      })

      if (data?.error_code === 0) {
        gettingEmpJobGlow(false);
        setEmpJobsData(data?.data)

      } else {
        gettingEmpJobGlow(false);
        setShow(false)
      }
    } catch (err) {
      console.log(err)
      setShow(false)
    }
  }

  const handleSelecJob = (e) => {
    if (e) {
      const parseJob = JSON.parse(e)
      const selectedObj = empJobsData?.filter((value) => value?.id === parseJob?.id);

      if (selectedObj?.length) {
        setSendInviteData({
          ...sendInviteData,
          job_id: selectedObj[0]?.id,
          professional_id: selectedObj[0]?.professional_id
        })
      } else {
        setSendInviteData({
          ...sendInviteData,
          job_id: '',
          professional_id: '',
          employer_feedback: ''
        })
      }
    }
  }

  const handleInterviewApi = async () => {
    try {
      if (sendInviteData?.professional_id) {
        const { data } = await axiosInstance.post("/invite_by_employer", { ...sendInviteData, invite_from: "pool_page" })
        if (data.error_code === 0) {
          setShow(false);
          setSendInviteData({
            job_id: '',
            professional_id: '',
            employer_feedback: ''
          })
        } else {
          toast.error(data?.message)
        }
      } else {
        toast.error("please select the job")
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleCopytext = (share_link) => {
    navigator.clipboard.writeText(share_link);
    toast.success("Link copied");
  };

  return (
    <>
      <div className={isShared ||
        (Cookie.get("Prof_id") && ["/employer_dashboard/pool", "/employer_dashboard/pool/"].includes(window.location.pathname)) ||
        (Cookie.get("prof_id_partner") && ["/partner_dashboard/pool", "/partner_dashboard/pool/"].includes(window.location.pathname)) ?

        "homePage-backgroundColor overflow-hidden "
        :
        "employer-pool min-vh-100"
      }>
        {
          isShared ||
            (Cookie.get("Prof_id") && ["/employer_dashboard/pool", "/employer_dashboard/pool/"].includes(window.location.pathname)) ||
            (Cookie.get("prof_id_partner") && ["/partner_dashboard/pool", "/partner_dashboard/pool/"].includes(window.location.pathname)) ?

            <div className="d-flex flex-wrap justify-content-center align-items-center py-5">
              <Card className="col-11 col-md-8 col-xl-6 border-0 rounded-4">
                <Card.Header className="bg-transparent py-3 border-0">
                  <button type="button" className="btn btn-outline-secondary d-flex align-items-center gap-2 py-2"
                    onClick={() => {
                      Cookie.remove("Prof_id")
                      Cookie.remove("prof_id_partner")
                      setIsShared(null)
                    }}>
                    <IoChevronBackCircle className="fs-5" /> Back
                  </button>
                </Card.Header>
                <Card.Body className="show_pool_page_professional overflow-scroll">
                  <p className={isShared ? "mb-1" : "d-none"} >
                    USER ID :{" "}
                    <strong>{isShared}</strong>
                  </p>
                  <CandidateProfile
                    professionalId={professionalId}
                    mobileScreen={mobileScreen}
                  />
                </Card.Body>

                {
                  ["/employer_dashboard/pool", "/employer_dashboard/pool/"].includes(window.location.pathname) ?
                    <Card.Footer className="bg-transparent">
                      <div className="col text-end">
                        <button className={Cookie.get("Prof_id") ? "btn btn-brand-color" : "btn placeholder rounded-2"}
                          onClick={() => handleInviteTonterview(decryptData(Cookie.get("Prof_id")))}
                          disabled={!Cookie.get("payment_status") || Cookie.get("payment_status") === "trialing"}
                        >
                          Invite to Apply
                        </button>
                      </div>
                    </Card.Footer>
                    :
                    null
                }
              </Card>
            </div>
            :
            //   <div className="vh-100">
            //     <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            //       <div className="d-flex  justify-content-center vh-80 align-items-center">
            //         <img src={images.noRecordsFound} width={250} height={250} />
            //       </div>
            //     </div>
            //   </div>
            //   :
            <div>
              <div className={`container-fluid  ${mobileScreen ? "px-3" : "px-5"} ${allArrayDataCopy.length < 1 ? "vh-80" : "h-100"}`}>
                <div id="section-1 "></div>
                <div className="row pt-3 align-items-end">
                  <div className="col-lg-6">
                    <p className="showing-results text-secondary mb-0 py-2">
                      {allArrayDataCopy.length > 0
                        ? `Showing : 1-${allArrayDataCopy.length} of ${formatNumber(totalNoOfRecords)} profiles`
                        : `Showing : 0 profiles`}
                    </p>
                  </div>

                  <div className="col-lg-6 " id="searchInputField">
                    <div
                      className={
                        pageContentLoaded || poolSearch
                          ? "d-flex position-relative"
                          : "d-none"
                      }
                    >
                      <InputGroup
                        className="home-search-icon fs-5"
                        reIcons={<IoIosSearch />}
                      />

                      <input
                        type="text"
                        className="form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border"
                        placeholder="Search by user id, skill, experience, education"
                        aria-label="default input example"
                        value={poolSearch}
                        onChange={(e) => handlePoolSearch(e)}
                        onKeyDown={handlekeydown}
                      />

                      {isSearched ? (
                        <div
                          className="searchButtonClick-superAdmin "
                          title="Search"
                          onClick={() => handleSearchData(1)}
                        >
                          <IoIosSearch />
                        </div>
                      ) : null}

                      <div
                        className="clearButtonClick-superAdmin"
                        title="Clear"
                        onClick={handleClearSearch}
                      >
                        <MdClear />
                      </div>
                    </div>
                  </div>
                </div>

                {allArrayDataCopy.length > 0 ?
                  allArrayDataCopy.map((value, i) => {
                    return (
                      <React.Fragment key={value.id}>
                        {value.about.length === 0 &&
                          value.experience.length === 0 &&
                          value.skills.length === 0 &&
                          value.education.length === 0 ? null : (
                          <div className={`card  border-0 shadow-sm ${mobileScreen ? "px-3" : "px-5"} py-3 my-4 placeholder-glow h-100`} >
                            <div className="row" id={i === 0 ? "firstCard" : ""}>
                              <div className="card-header bg-transparent d-flex justify-content-between align-items-center">
                                <p className={pageContentLoaded ? "mb-1" : "placeholder py-2 rounded-2"} >
                                  USER ID :{" "}
                                  <strong>{value.professional_id}</strong>
                                </p>

                                <div className={`d-flex flex-wrap justify-content-end col-xl-3`} id={`viewFullProfile${value.id}Button`} >
                                  <button
                                    type="button"
                                    className={'btn border-brand-color py-1'}
                                    data-bs-toggle="modal"
                                    data-bs-target="#fullProfileModal"
                                    onClick={() => handleViewFullProfile(value.professional_id)}
                                  >
                                    View full profile
                                  </button>

                                  <button
                                    type="button"
                                    className="btn  btn-transparent border border-brand-color candidate-right-side-btn ms-3"
                                    data-bs-toggle="modal"
                                    data-bs-target="#shareModal"
                                    onClick={() => setShareProfessional(value.professional_id)}
                                  >
                                    <FaShare />
                                    <span className='ps-2'>Share</span>
                                  </button>
                                </div>
                              </div>

                              {value.about.length === 0 ? null : (
                                <div className="col-lg-6 col-md-12 ">
                                  <InfoEditCard
                                    pageContentLoaded={pageContentLoaded}
                                    cardHeadingIcon={
                                      <FaUserTie
                                        className={
                                          pageContentLoaded
                                            ? "me-4 brand-color fs-4"
                                            : "me-4  fs-4 placeholder rounded-2"
                                        }
                                      />
                                    }
                                    cardHeading="About"
                                    id="pageTop"
                                    placeholder="Provide a brief description about yourself"
                                    cardContent={
                                      value.about.length > 200
                                        ? `${value.about.slice(0, 250)}..`
                                        : `${value.about}`
                                    }
                                    mobileScreen={mobileScreen}
                                  />
                                </div>
                              )}

                              {value.experience.length === 0 ? null : (
                                <div className="col-lg-6 col-md-12">
                                  <InfoAddCard
                                    pageContentLoaded={pageContentLoaded}
                                    cardHeadingIcon={
                                      <PiBagFill
                                        className={
                                          pageContentLoaded
                                            ? "me-4 brand-color fs-4"
                                            : "me-4  fs-4 placeholder rounded-2"
                                        }
                                      />
                                    }
                                    cardHeading="Experience"
                                    placeholder="Your experience details will be displayed here"
                                    arrayContent={value.experience[0]}
                                    currentPage="employerPool"
                                    mobileScreen={mobileScreen}
                                  />
                                </div>
                              )}
                              {value.skills.length === 0 ? null : (
                                <div className="col-lg-6 col-md-12">
                                  <div className="card mt-3 border-0 rounded-4">
                                    <div
                                      className={`card-body ${mobileScreen ? "px-0 py-0" : ""
                                        }`}
                                    >
                                      <div className="d-flex justify-content-between ms-1">
                                        <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                          <HiLightBulb
                                            className={
                                              pageContentLoaded
                                                ? "me-4 brand-color fs-4"
                                                : "me-4  fs-3 placeholder rounded-2"
                                            }
                                          />
                                          <span
                                            className={
                                              pageContentLoaded
                                                ? ""
                                                : "placeholder px-3 w-100 py-1  rounded-1"
                                            }
                                          >
                                            Skills
                                          </span>
                                        </label>
                                      </div>

                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                          {value.skills.length === 0 ? (
                                            <p
                                              className={
                                                pageContentLoaded
                                                  ? "mt-0 word-space-content px-0 ms-1"
                                                  : "placeholder px-3 py-2 mt-0 rounded-1"
                                              }
                                            >
                                              Your skills will be displayed here
                                            </p>
                                          ) : (
                                            value.skills
                                              .slice(0, 5)
                                              .map((skill, id) => {
                                                return (
                                                  <React.Fragment key={skill.id}>
                                                    <div className="col mt-0  px-0 me-2">
                                                      <div
                                                        className={
                                                          pageContentLoaded
                                                            ? "border rounded-2 p-2 fw-bold mb-3 "
                                                            : "border rounded-2 p-2 fw-bold mb-4 placeholder"
                                                        }
                                                      >
                                                        <span className="textTransform">
                                                          {skill.skill_name}
                                                        </span>{" "}
                                                        {skill.skill_level
                                                          ? "-"
                                                          : null}{" "}
                                                        <span className="fw-normal">
                                                          {skill.skill_level}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </React.Fragment>
                                                );
                                              })
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {value.education.length === 0 ? null : (
                                <div className="col-lg-6 col-md-12">
                                  <InfoAddCard
                                    pageContentLoaded={pageContentLoaded}
                                    cardHeadingIcon={
                                      <FaGraduationCap
                                        className={
                                          pageContentLoaded
                                            ? "me-4 brand-color fs-4"
                                            : "me-4  fs-4 placeholder rounded-2"
                                        }
                                      />
                                    }
                                    cardHeading="Education"
                                    placeholder="Your education details will be displayed here"
                                    arrayContent={value.education[0]}
                                    currentPage="employerPool"
                                    mobileScreen={mobileScreen}
                                  />
                                </div>
                              )}
                              <hr className={`mt-2 ${inviteInterviewBtn
                                ? "d-block"
                                : "visually-hidden"
                                }`} />
                            </div>

                            <div className={`${inviteInterviewBtn ? "d-block" : "visually-hidden"}`}>
                              <div className={`mt-4 ${mobileScreen ? "text-center" : "text-end"}`} id={`inviteToInterview${value.id}Button`}>
                                <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`} className={pageContentLoaded ? "btn btn-brand-color" : "btn  placeholder rounded-2"}
                                  onClick={() => handleInviteTonterview(value?.professional_id)}
                                  disabled={!Cookie.get("payment_status") || Cookie.get("payment_status") === "trialing"}
                                >
                                  Invite to Apply
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })
                  : pageContentLoaded ?
                    <div className="vh-75">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="d-flex  justify-content-center vh-80 align-items-center">
                          <img
                            src={images.noRecordsFound}
                            width={250}
                            height={250}
                          />
                        </div>
                      </div>
                    </div>
                    :
                    <Fragment>
                      <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <InfoEditCard
                              pageContentLoaded={pageContentLoaded}
                              cardHeadingIcon={
                                <FaUserTie
                                  className={
                                    pageContentLoaded
                                      ? "me-4 brand-color fs-4"
                                      : "me-4  fs-4 placeholder rounded-2"
                                  }
                                />
                              }
                              cardHeading="About"
                              id="pageTop"
                              placeholder="Provide a brief description about yourself"
                              cardContent="about content"
                            />
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <InfoEditCard
                              pageContentLoaded={pageContentLoaded}
                              cardHeadingIcon={
                                <FaUserTie
                                  className={
                                    pageContentLoaded
                                      ? "me-4 brand-color fs-4"
                                      : "me-4  fs-4 placeholder rounded-2"
                                  }
                                />
                              }
                              cardHeading="About"
                              id="pageTop"
                              placeholder="Provide a brief description about yourself"
                              cardContent="about content"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="card mt-3 border-0 shadow-sm rounded-4">
                              <div className="card-body">
                                <div className="d-flex justify-content-between ms-1">
                                  <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                    <HiLightBulb
                                      className={
                                        pageContentLoaded
                                          ? "me-4 brand-color fs-4"
                                          : "me-4  fs-3 placeholder rounded-2"
                                      }
                                    />
                                    <span
                                      className={
                                        pageContentLoaded
                                          ? ""
                                          : "placeholder px-3 w-100 py-1  rounded-1"
                                      }
                                    >
                                      Skills
                                    </span>
                                  </label>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                    <p
                                      className={
                                        pageContentLoaded
                                          ? "mt-0 word-space-content px-0 ms-1"
                                          : "placeholder px-3 py-2 mt-0 rounded-1"
                                      }
                                    >
                                      Your skills will be displayed here
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <InfoEditCard
                              pageContentLoaded={pageContentLoaded}
                              cardHeadingIcon={
                                <FaUserTie
                                  className={
                                    pageContentLoaded
                                      ? "me-4 brand-color fs-4"
                                      : "me-4  fs-4 placeholder rounded-2"
                                  }
                                />
                              }
                              cardHeading="About"
                              id="pageTop"
                              placeholder="Provide a brief description about yourself"
                              cardContent="about content"
                            />
                          </div>
                        </div>

                        <div className="mt-4 text-end">
                          <button
                            className={
                              pageContentLoaded
                                ? "btn btn-brand-color"
                                : "btn  placeholder rounded-2"
                            }
                            data-bs-toggle="modal"
                            data-bs-target="#fullProfileModal"
                          >
                            Click here to see full profile
                          </button>
                        </div>
                      </div>
                      <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <InfoEditCard
                              pageContentLoaded={pageContentLoaded}
                              cardHeadingIcon={
                                <FaUserTie
                                  className={
                                    pageContentLoaded
                                      ? "me-4 brand-color fs-4"
                                      : "me-4  fs-4 placeholder rounded-2"
                                  }
                                />
                              }
                              cardHeading="About"
                              id="pageTop"
                              placeholder="Provide a brief description about yourself"
                              cardContent="about content"
                            />
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <InfoEditCard
                              pageContentLoaded={pageContentLoaded}
                              cardHeadingIcon={
                                <FaUserTie
                                  className={
                                    pageContentLoaded
                                      ? "me-4 brand-color fs-4"
                                      : "me-4  fs-4 placeholder rounded-2"
                                  }
                                />
                              }
                              cardHeading="About"
                              id="pageTop"
                              placeholder="Provide a brief description about yourself"
                              cardContent="about content"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="card mt-3 border-0 shadow-sm  rounded-4">
                              <div className="card-body">
                                <div className="d-flex justify-content-between ms-1">
                                  <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                    <HiLightBulb
                                      className={
                                        pageContentLoaded
                                          ? "me-4 brand-color fs-4"
                                          : "me-4  fs-3 placeholder rounded-2"
                                      }
                                    />
                                    <span
                                      className={
                                        pageContentLoaded
                                          ? ""
                                          : "placeholder px-3 w-100 py-1  rounded-1"
                                      }
                                    >
                                      Skills
                                    </span>
                                  </label>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                    <p
                                      className={
                                        pageContentLoaded
                                          ? "mt-0 word-space-content px-0 ms-1"
                                          : "placeholder px-3 py-2 mt-0 rounded-1"
                                      }
                                    >
                                      Your skills will be displayed here
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <InfoEditCard
                              pageContentLoaded={pageContentLoaded}
                              cardHeadingIcon={
                                <FaUserTie
                                  className={
                                    pageContentLoaded
                                      ? "me-4 brand-color fs-4"
                                      : "me-4  fs-4 placeholder rounded-2"
                                  }
                                />
                              }
                              cardHeading="About"
                              id="pageTop"
                              placeholder="Provide a brief description about yourself"
                              cardContent="about content"
                            />
                          </div>
                        </div>

                        <div className="mt-4 text-end">
                          <button
                            className={
                              pageContentLoaded
                                ? "btn btn-brand-color"
                                : "btn  placeholder rounded-2"
                            }
                            data-bs-toggle="modal"
                            data-bs-target="#fullProfileModal"
                          >
                            Click here to see full profile
                          </button>
                        </div>
                      </div>
                    </Fragment>
                }
              </div>

              <div className="container-fluid load-more-button-container">
                {loadMoreLoading === true ?
                  <div className="d-flex justify-content-center ">
                    <div className="spinner-border brand-color" role="status">
                      <span className="visually-hidden ">Loading...</span>
                    </div>
                  </div>
                  :
                  allArrayDataCopy.length >= 5 ?
                    <div className="my-4 text-end">
                      <button
                        id="loadMoreButton"
                        className="btn btn-brand-color"
                        onClick={() => handleLoadMore(allArrayDataCopy[allArrayDataCopy.length - 1].id)}
                        disabled={allArrayDataCopy?.length === totalNoOfRecords}
                      >
                        Load more
                      </button>
                    </div>
                    :
                    null
                }
              </div>

              {/* scroll to top */}
              <div
                className="scroll-to-top-icon"
                id="scroll-to-top-icon"
                onClick={scrollToTop}
                title="Scroll to top"
                style={{ display: isVisible ? "block" : "none" }} // Show/hide button based on visibility state
              >
                <BsFillArrowUpCircleFill className="fs-1 brand-color" />
              </div>
            </div>
        }
      </div>

      <div
        className="modal fade"
        id="fullProfileModal"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div
            className={`modal-content ${mobileScreen ? "px-0 " : "px-3"} mx-2 `}
          >
            <div className="modal-header border-bottom-0 ">
              <h1 className="modal-title fs-5 mt-2" id="staticBackdropLabel">
                Applicant full profile
              </h1>
              <button
                id="closeViewProfileButton"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body border-bottom-0 ">
              <div className="container px-0">
                {professionalId !== null ? (
                  <CandidateProfile
                    professionalId={professionalId}
                    mobileScreen={mobileScreen}
                  />
                ) : null}
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <div className="container">
                <div className="row float-end">
                  <div className="col-lg-12 ">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      data-bs-dismiss="modal"
                    >
                      <span>Cancel</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* invite to interview model */}
      <div className="inviteInterview-modal-container">
        <Modal
          backdrop="static"
          keyboard={false}
          show={show}
          onHide={handleInterviewModal}
          size="lg"
          centered>

          <Modal.Header closeButton>
            <Modal.Title><h5 className="fw-bold p-2">Invite to Apply</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="inviteInterview-modal-body d-flex flex-column p-3">
              {
                empJobGlow ?
                  <div className="spinner-modal-body-size">
                    <div className="col text-center">
                      <div className="spinner-border brand-color" role="status">
                        <span className="visually-hidden ">Loading...</span>
                      </div>
                      <p className="mt-2 text-secondary">Getting data...</p>
                    </div>
                  </div>
                  :
                  <Fragment>
                    <div className="inviteInterview-selectJob d-flex flex-column">
                      <h6 className="fw-bold">Please Select the Job</h6>

                      <Form.Select aria-label="Default select example" onChange={(e) => handleSelecJob(e.target.value)}>
                        <option value=""></option>
                        {empJobsData?.map((value, index) => (
                          <option value={JSON.stringify(value)} key={index} disabled={value?.job_status === "Applied"}>
                            {value?.job_title}

                            <span>
                              {value?.job_status === "Applied" ? `(${value?.job_status})` : null}
                            </span>
                          </option>
                        ))}
                      </Form.Select>

                    </div>
                    <div className="inviteInterview-InputText mt-4">
                      <h6 className="fw-bold ">Why would you like this professional to apply for this job?</h6>
                      <p className="fs-6">This message will be shared with the professional to provide context for the invitation. (Optional)</p>
                      <Form.Control as="textarea" rows={7} placeholder="Enter Your Text Here" onChange={(e) => setSendInviteData({ ...sendInviteData, employer_feedback: e.target.value })}></Form.Control>

                    </div>
                  </Fragment>
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex w-100">
              <Button
                variant="outline-secondary"
                className="mx-2 w-50"
                disabled={empJobGlow}
                onClick={handleInterviewModal}
              >
                Cancel
              </Button>


              <Button
                variant="brand-color"
                className="w-50"
                onClick={handleInterviewApi}
                disabled={empJobGlow}
              >
                Invite
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>

      {/* share professional  */}
      <div
        className="modal fade"
        id="shareModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">  Share </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0 ">
              <div className="mb-3 position-relative">
                <label htmlFor="message-text" className="col-form-label">
                  Share Profile
                </label>
                <input
                  className="form-control  mx-auto mt-0 linkFieldSize"
                  id="message-text"
                  value={process.env.REACT_APP_SHARE_BASEURL + window.location.pathname + (window.location.pathname === "/partner_dashboard/pool" ? "?prof_id_partner=" : "?prof_id=") + encryptData(shareProfessional)}
                  readOnly
                />
                <button
                  type="button"
                  className="btn btn-brand-color button-position"
                  onClick={() => handleCopytext(process.env.REACT_APP_SHARE_BASEURL + window.location.pathname + (window.location.pathname === "/partner_dashboard/pool" ? "?prof_id_partner=" : "?prof_id=") + encryptData(shareProfessional))}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {(pageContentLoaded && Cookie.get("isEmployerPoolFirstVisit")) ||
        Cookie.get("isPartnerPoolFirstVisit") ? (
        allArrayDataCopy.length === 0 ? (
          <Joyride
            callback={handleJoyrideCallbackForNoData}
            styles={{
              options: {
                width: "500px",
                borderRadius: "60px",
              },
              buttonNext: {
                background: "#e38212",
                outline: "none",
              },
              buttonSkip: {
                textDecoration: "underline",
              },
              buttonBack: {
                color: "#212529",
                backgroundColor: "#fff",
                border: " 0px",
                borderRadius: "4px",
                color: "#000",
                cursor: "pointer",
                fontSize: "16px",
                lineHeight: "1",
                padding: "8px",
                appearance: "none",
                outline: "1px solid grey",
              },
            }}
            scrollOffset={500}
            continuous
            disableOverlayClose={true}
            hideCloseButton
            showSkipButton
            showProgress
            steps={stepsForNoData}
            run={runForNoData}
          />
        ) : (
          <Joyride
            callback={handleJoyrideCallback}
            styles={{
              options: {
                width: "500px",
                borderRadius: "60px",
              },
              buttonNext: {
                background: "#e38212",
                outline: "none",
              },
              buttonSkip: {
                textDecoration: "underline",
              },
              buttonBack: {
                color: "#212529",
                backgroundColor: "#fff",
                border: " 0px",
                borderRadius: "4px",
                color: "#000",
                cursor: "pointer",
                fontSize: "16px",
                lineHeight: "1",
                padding: "8px",
                appearance: "none",
                outline: "1px solid grey",
              },
            }}
            scrollOffset={500}
            continuous
            disableOverlayClose={true}
            hideCloseButton
            showSkipButton
            showProgress
            steps={steps}
            run={run}
          />
        )
      ) : null}
    </>
  );
};

export default EmployerPool;